export default __webpack_public_path__ + "locales/sr-Cyrl-RS/CreateEditRoomDialog.json?hash=2f385aa28b35d12915742ff6c2c3d09f";